import {useEffect, useRef, useState} from "react";
import styled from 'styled-components';
import React from "react";
import {isMobileDevice} from "../../hooks/mobile/isMobile";


const SBaseModal = styled.div`
    min-width: 400px;
    max-width: 50dvw;
    background-color: ${({ theme }) => theme.colors.bg};
    border-radius: ${({ theme }) => theme.blocks.radius};
    border: 1px solid ${({ theme }) => theme.colors.border};
    ${props => props.IsMobile ? "margin: 0 20px; width: calc(100% - 40px); min-width: unset; max-width: unset;" : ""}
    transition: 0.4s transform;
    transition-timing-function: cubic-bezier(0, 0, 0.52, 1.02);
    
    > * {
        padding: ${({ theme }) => theme.blocks.padding};
    }
`;


export const ModalHeader = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    
    * {
        font-weight: 600;
        font-size: 18px;
    }
    ${props => isMobileDevice() ? 'text-align: center;' : ""}
    
`;

export const ModalFooter = styled.div`
    display: flex;
    
    > *:not(:last-child) {
        margin-right: 15px;
    }
`;

export function BaseModal({ children, isOpen, setOpen, isMobile=isMobileDevice(), onMouseUp=null }) {
    const modalRef = useRef(null);
    const backdropRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            backdropRef.current.status = "opening";
            backdropRef.current.style.display = "flex";

            setTimeout(() => {
                modalRef.current.style.transform = "translateY(0dvh)";
                //backdropRef.current.style.opacity = "1";
                backdropRef.current.style.backgroundColor = "#000000ba";
            }, 10);
        } else {
            modalRef.current.style.transform = "translateY(-100dvh)";
            backdropRef.current.style.display = "flex";
            //backdropRef.current.style.opacity = "0";
            backdropRef.current.style.backgroundColor = "#00000000";
            backdropRef.current.status = "closing";
            setTimeout(() => {
                if (backdropRef.current.status === "closing") backdropRef.current.style.display = "none";
            }, 400);
        }
    }, [isOpen]);


    return <div ref={backdropRef} onMouseUp={onMouseUp} className="modal-backdrop" style={{display: "none"}}>
        <SBaseModal ref={modalRef} IsMobile={isMobile}>{children}</SBaseModal>
    </div>;
}
